"use strict";

angular.module("vendor")
.component("catalogEntryTab", {
    bindings: {
        catalog: "="
    },
    templateUrl: require("./catalog-entry-tab.component.html"),
    controller: function(
        $scope, $stateParams, $rootScope, $interval, $q, Workflow, StateExtensionService, gettextCatalog, FlashBag,
        FormError, Language, Catalog, UserService, PatternService, ProductSequenceService, CatalogEntryService,
        ProductService, ProductVariantsService, CATALOG_HEADER_OFFSET
    ) {
        var _this = this;
        var promises = [];
        Language.initializeScope($scope, null, "locale");

        $scope.INVENTORY_QUANTITY_MAX = ProductService.INVENTORY_QUANTITY_MAX;
        $scope.PRODUCT_QUANTITY_MAX = ProductService.PROCUT_QUANTITY_MAX;

        $scope.pattern = PatternService;
        $scope.catalogEntryService = CatalogEntryService;
        $scope.catalogFactory = Catalog;
        $scope.paginationCatalogEntry = {};
        $scope.catalogEntry = {};
        $scope.expandedCatalogentry = false;
        $scope.nestedData = {
            searchTermCatalogEntry: ""
        };
        $scope.ordering = {
            isFetching: false
        };

        $scope.sequences = ProductSequenceService.query();

        $scope.variantOptions = [];
        promises.push(
            ProductVariantsService.getOptions().then(function onSuccess(response) {
                $scope.variantOptions = response.data;
            })
        );

        this.createProduct = function() {
            Workflow.saveAndContinueAt(this.catalog, "productEdit");
            Workflow.addToFormData("catalogEdit", "section", "products");
        };

        this.updateCatalogStatus = function() {
            StateExtensionService.updateUrlParams({"#": "sharing"});
            $scope.$emit("updateCatalogStatus");
        };

        this.fetchCatalogEntries = function() {
            $q.all(promises).then(function onSuccess() {
                var search = $scope.nestedData.searchTermCatalogEntry;
                var page = $scope.paginationCatalogEntry.current_page;

                CatalogEntryService.query(_this.catalog.id, search, page).$promise
                .then(function onSuccess(data) {
                    $scope.paginationCatalogEntry = data.pagination;
                    $scope.catalogEntries = data.results;

                    if ($scope.catalogEntries.length === 0) {
                        $scope.$emit("updateWizardMenu");
                    }
                });
            });
        };

        this.createCatalogEntry = function(form) {
            if (form.$valid && $scope.catalogEntry && $scope.catalogEntry.product) {
                CatalogEntryService.create($scope.catalogEntry, _this.catalog.id).then(
                    function() {
                        var message = gettextCatalog.getString("The product was added to the catalog.");
                        FlashBag.alertWithContainer("success", "catalog-entry", message);
                        $scope.nestedData.productAutoCompleteText = "";
                        $scope.catalogEntry = {};
                        _this.fetchCatalogEntries();
                        $scope.$emit("updateWizardMenu");
                    },
                    function(response) {
                        FlashBag.apiError(response);
                    }
                );
            }
            else {
                FormError.focus(form.$name, CATALOG_HEADER_OFFSET);
                return true;
            }
        };

        this.updateCatalogEntryInventoryQuantity = function(form, catalogEntry) {
            if (catalogEntry.initial_inventory_quantity === catalogEntry.inventory_quantity || !form.$valid) {
                return;
            }

            CatalogEntryService.patchField(
                catalogEntry.id,
                {inventory_quantity: catalogEntry.inventory_quantity}
            ).then(function onSuccess(data) {
                catalogEntry.inventoryQuantitySaved = true;
                catalogEntry.initial_inventory_quantity = data.initial_inventory_quantity;
                form.$setPristine();

                $interval(function() {
                    catalogEntry.inventoryQuantitySaved = false;
                }, FlashBag.getSuccessMessageLifetime(), 1);
            }, function onError(response) {
                FlashBag.apiError(response);
            });
        };

        this.updateCatalogEntryQuantityMin = function(form, catalog_entry) {
            if (catalog_entry.initial_quantity_min === catalog_entry.quantity_min || !form.$valid) {
                return;
            }

            CatalogEntryService.patchField(catalog_entry.id, {quantity_min: catalog_entry.quantity_min}).then(
                function(data) {
                    catalog_entry.quantityMinSaved = true;
                    catalog_entry.initial_quantity_min = data.initial_quantity_min;
                    form.$setPristine();

                    $interval(function() {
                        catalog_entry.quantityMinSaved = false;
                    }, FlashBag.getSuccessMessageLifetime(), 1);
                }
            );
        };

        this.updateCatalogEntryQuantityMax = function(form, catalog_entry) {
            if (catalog_entry.initial_quantity_max === catalog_entry.quantity_max || !form.$valid) {
                return;
            }

            CatalogEntryService.patchField(catalog_entry.id, {quantity_max: catalog_entry.quantity_max}).then(
                function(data) {
                    catalog_entry.quantityMaxSaved = true;
                    catalog_entry.initial_quantity_max = data.initial_quantity_max;
                    form.$setPristine();

                    $interval(function() {
                        catalog_entry.quantityMaxSaved = false;
                    }, FlashBag.getSuccessMessageLifetime(), 1);
                }
            );
        };

        this.updateCatalogEntryPrice = function(form, catalogEntry) {
            if (
                parseFloat(catalogEntry.initial_price).toFixed(5) === parseFloat(catalogEntry.price).toFixed(5)
                || !form.$valid
            ) {
                return;
            }

            CatalogEntryService.patchField(catalogEntry.id, {price: catalogEntry.price}).then(
                function(data) {
                    catalogEntry.priceSaved = true;
                    catalogEntry.initial_price = data.initial_price;
                    catalogEntry.discount = data.discount;
                    catalogEntry.rebate = data.rebate;
                    catalogEntry.discounted_price = data.discounted_price;
                    catalogEntry.rebate_amount = data.rebate_amount;
                    form.$setPristine();

                    $interval(function() {
                        catalogEntry.priceSaved = false;
                    }, FlashBag.getSuccessMessageLifetime(), 1);
                }
            );
        };

        this.updateCatalogEntryPackagingQuantity = function(form, catalog_entry) {
            if (catalog_entry.initial_packaging_quantity === catalog_entry.packaging_quantity || !form.$valid) {
                return;
            }

            CatalogEntryService.patchField(catalog_entry.id, {packaging_quantity: catalog_entry.packaging_quantity}).then(
                function(data) {
                    catalog_entry.packagingQuantitySaved = true;
                    catalog_entry.initial_packaging_quantity = data.initial_packaging_quantity;
                    catalog_entry.discount = data.discount;
                    catalog_entry.rebate = data.rebate;
                    catalog_entry.discounted_price = data.discounted_price;
                    catalog_entry.rebate_amount = data.rebate_amount;
                    form.$setPristine();

                    $interval(function() {
                        catalog_entry.packagingQuantitySaved = false;
                    }, FlashBag.getSuccessMessageLifetime(), 1);
                }
            );
        };

        this.updateCatalogEntryState = function(catalogEntry) {
            CatalogEntryService.patchField(catalogEntry.id, {enabled: catalogEntry.enabled})
            .then(function onSuccess() {
                $scope.$emit("updateWizardMenu");
            });
        };

        this.onDeleteCatalogEntry = function() {
            FlashBag.alertWithContainer(
                "success", "catalog-entry",
                gettextCatalog.getString("The catalog entry has successfully been deleted.")
            );
            $(window).scrollTop($("[name=catalog-entry]").offset().top + CATALOG_HEADER_OFFSET);
            _this.fetchCatalogEntries();
            $scope.$emit("updateWizardMenu");
        };

        this.patchCatalogField = function(field) {
            var params = {id: _this.catalog.id};
            params[field] = _this.catalog[field];
            return Catalog.patch(params).then(function(data) {
                _this.catalog[field] = data[field];
                _this.fetchCatalogEntries();
            }, FlashBag.apiError);
        };

        this.onSequenceChanged = function() {
            var params = {
                id: _this.catalog.id,
                sequence_sharing_choice: _this.catalog.sequence_sharing_choice
            };
            return Catalog.patch(params).then(function(data) {
                _this.catalog.sequence_sharing_choice = data.sequence_sharing_choice;
                _this.catalog.use_custom_sequence = data.use_custom_sequence;
                _this.catalog.shared_product_sequence = data.shared_product_sequence;
                _this.fetchCatalogEntries();
            }, FlashBag.apiError);
        };

        this.getVariantTableColSpan = function() {
            var colSpan = 5;
            if (_this.catalog && _this.catalog.use_custom_sequence && _this.catalog.share_suggested_order) {
                colSpan += 1;
            }
            if ($scope.isInventoryAvailable) {
                colSpan += 1;
            }
            if ($scope.isQuantityConstraintAvailable) {
                colSpan += 1;
            }
            if ($scope.isPackagingQuantityAvailable) {
                colSpan += 1;
            }
            return colSpan;
        };

        this.goBack = function() {
            $scope.$emit("goBack");
        };

        this.fetchCatalogEntries();

        $scope.$on("fetchCatalogEntries", function() {
            _this.fetchCatalogEntries();
        });

        function updateWorkFlowData() {
            var formData = Workflow.getFormData("catalogEdit");
            var catalogId = $stateParams.id;

            if (formData && formData.id == catalogId) {
                $scope.Catalog = formData;

                if (formData["catalogEntry.product"]) {
                    var product = formData["catalogEntry.product"];
                    product.BarcodeFormat = product.BarcodeFormat_format;
                    $scope.catalogEntry.product = product;
                    delete formData["catalogEntry.product"];
                }
            }
        }

        updateWorkFlowData();

        UserService.isUserFetched().then(function onSuccess(user) {
            if (user && user.vendor) {
                $scope.isInventoryAvailable = user.vendor.inventory_holder === "catalog_entry";
                $scope.isQuantityConstraintAvailable = user.vendor.quantity_constraint_holder === "catalog_entry";
                $scope.isPackagingQuantityAvailable = user.vendor.use_catalog_packaging_quantity;
                $scope.setInventoryQuantityZero = user.vendor.set_quantity_zero_at_inventory_creation;

                if ($scope.isInventoryAvailable && $scope.setInventoryQuantityZero) {
                    $scope.catalogEntry.inventory_quantity = 0;
                }
            }
        });
    }
});




//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-entry-tab/catalog-entry-tab.component.js
// module id = 948
// module chunks = 0